module.exports = __webpack_public_path__ + "static/whoafraid_book-ad93caef93b671282213b7e68ae2c7b5.jpg";